// extracted by mini-css-extract-plugin
module.exports = {"Achievements":"Achievements_Achievements__13SzM","Achievement":"Achievements_Achievement__3OdSe","AchievementIcon":"Achievements_AchievementIcon__2zZmf"};